import { graphql, withPrefix } from 'gatsby'

import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseIcon from 'src/components/ArBaseIcon/ArBaseIcon'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
// ArComponents
import ArBlogHeader from 'src/components/blog/ArBlogHeader/ArBlogHeader'
import ArCompanyAdvertisement from 'src/components/ArCompanyAdvertisement/ArCompanyAdvertisement'
import ArFeaturedArticles from 'src/components/ArFeaturedArticles/ArFeaturedArticles'
import ArMailingListForm from 'src/components/ArMailingListForm/ArMailingListForm'
import ArMonoTag from 'src/components/typography/ArMonoTag'
import ArSeo from 'src/components/ArSeo/ArSeo'
import ArTextContent from 'src/components/ArTextContent/ArTextContent'
import React from 'react'
import { media } from 'src/styles/styled-components'
import moment from 'moment'
import routesConfig from 'src/routes.config'
import styled from 'styled-components'

const StyledContentContainer = styled(ArBaseContainer)`
  padding-top: 25px;
  ${ media.tablet`
    padding-top: 40px;
  ` }
  ${ media.desktop`
    max-width: 800px;
  ` }
`
const StyledImage = styled(ArBaseImage)`
  margin-bottom: 20px;
  ${ media.tablet`
    margin-bottom: 40px;
  ` }
`

const StyledArticleFooter = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  ${ media.tablet`
    flex-direction: row;
  ` }
`

const StyledAuthors = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  > div {
    align-items: center;
    display: flex;
    flex-direction: row;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
  }
`

const StyledAuthorAvatar = styled.div`
  background-image: url(${ ({ image }) => image });
  background-position: center;
  background-size: cover;
  border-radius: 100%;
  flex-shrink: 0;
  height: 24px;
  width: 24px;
  ${ media.tablet`
    height: 44px;
    width: 44px;
  ` }
`

const StyledAuthorName = styled(ArMonoTag)`
  margin-left: 10px;
  ${ media.tablet`
    margin-left: 20px;
    margin-right: 30px;
    color: ${ p => p.theme.colors.black };
  ` }
`

const StyledShare = styled.div`
  align-items: center;
  display: flex;
`

const StyledShareTitle = styled(ArMonoTag)`
  color: ${ p => p.theme.colors.black };
`

const StyledShareLink = styled.a`
  padding: 10px;
`

class ArBlogPost extends React.Component {
  getPostData () {
    const { post } = this.props.data

    return {
      title: post.title ? post.title.title : 'no title',
      body: post.childContentfulPostBodyRichTextNode ? post.childContentfulPostBodyRichTextNode.childContentfulRichText.html : 'no data',
      description: post.description ? post.description.description : 'no desc',
      category: post.category ? post.category[0].title : 'no category',
      author: Array.isArray(post.author) ? post.author.map(author => ({
        name: author.name || 'no author name',
        image: author.profilePhoto.file.url || '',
      })) : [{
        name: post.author ? post.author[0].name : 'no author name',
        image: post.author && post.author[0].profilePhoto ? post.author[0].profilePhoto.file.url : '',
      }],
      image: post.featuredImage ? post.featuredImage.file.url : '',
      isPressRelease: post.isPressRelease,
      date: moment(post.date).format('DD.MM.YYYY'),
    }
  }

  get featuredArticles () {
    return !this.props.data.featuredArticles ? [] : this.props.data.featuredArticles.edges.map(({ node: article }) => {
      return {
        slug: article.slug,
        image: {
          url: article.featuredImage ? article.featuredImage.file.url : '',
          alt: article.featuredImage ? article.featuredImage.title : 'no title',
        },
        title: article.title ? article.title.title : 'no title',
        description: article.description.description,
        author: {
          image: article.author && article.author[0].profilePhoto ? article.author[0].profilePhoto.file.url : '',
          name: article.author && article.author[0].name,
        },
        category: article.category ? article.category[0].title : 'no category',
      }
    })
  }

  locationUrl () {
    return typeof window !== 'undefined' ? window.location.href : ''
  }

  render () {
    const data = this.getPostData()
    const { pageContext: { slug } } = this.props

    return (
      <React.Fragment>
        <ArSeo
          title={`${ data.title } - Blog - artificial.`}
          description={data.description}
          image={data.image}
          imagePrefix="https:"
          author={data.author}
          type="article"
          tag={data.category}
          path={routesConfig.company.blog({ slug })}
        />

        <ArBlogHeader title={data.title} isPressRelease={data.isPressRelease} date={data.date} category={data.category}/>
        <StyledContentContainer>
          <StyledImage src={data.image}/>
          <ArTextContent contentHTML={data.body}></ArTextContent>
          <StyledArticleFooter>
            <StyledAuthors>
              {data.author.map((author, index) => (
                <div key={index}>
                  <StyledAuthorAvatar image={author.image}/>
                  <StyledAuthorName>{author.name}</StyledAuthorName>
                </div>
              ))}
            </StyledAuthors>
            <StyledShare>
              <StyledShareTitle>Share</StyledShareTitle>
              <StyledShareLink target="_blank" rel="noopener" href={`https://twitter.com/intent/tweet?text=${ data.title }&url=${ this.locationUrl() }`}>
                <ArBaseIcon name="twitter-blue" size={20} />
              </StyledShareLink>
              <StyledShareLink target="_blank" rel="noopener" href={`https://www.linkedin.com/shareArticle?mini=true&url=${ this.locationUrl() }&title=${ data.title }`}>
                <ArBaseIcon name="linedin-blue" size={20} />
              </StyledShareLink>
            </StyledShare>
          </StyledArticleFooter>
          <ArCompanyAdvertisement
            images={[
              { url: withPrefix('img/ArCompanyAdvertisement1a.png'), alt: '' },
              { url: withPrefix('img/ArCompanyAdvertisement1b.png'), alt: '' },
              { url: withPrefix('img/ArCompanyAdvertisement1b.png'), alt: '' },
            ]}
            logo={{
              url: withPrefix('img/logoBlack.svg'),
              alt: 'Artificial logo',
            }}
            description={'We build superior products that harmonise the insurance experience for you and your customers.'}
            cta={{
              url: '/',
              title: 'Find out how we can help your business →',
            }}
          />
        </StyledContentContainer>
        <ArMailingListForm />
        {this.featuredArticles.length === 3 && <ArFeaturedArticles articles={this.featuredArticles} />}
      </React.Fragment>
    )
  }
}

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    post: contentfulPost(
      slug: { eq: $slug }
    ) {
      id
      title {
        title
      }
      body {
        body
      }
      description {
        description
      }
      featuredImage {
        file {
          url
        }
        title
      }
      childContentfulPostBodyRichTextNode {
        childContentfulRichText{
          html
        }
      }
      author {
        id
        name
        profilePhoto {
          file {
            url
          }
        }
      }
      isPressRelease
      category {
        title
      }
      date
    }
    featuredArticles: allContentfulPost(
      limit: 3,
      filter:{
        featured: {
          eq: true
        }
      }
    ) {
      edges {
        node {
          id
          slug
          title {
            title
          }
          description {
            description
          }
          featuredImage {
            file {
              url
            }
            title
          }
          author{
            name
            profilePhoto {
              file {
                url
              }
            }
          }
          category {
            title
          }
        }
      }
    }
  }
`

export default ArBlogPost
